import { render, staticRenderFns } from "./ProposalsList.vue?vue&type=template&id=2e19c7b1&scoped=true&"
import script from "./ProposalsList.vue?vue&type=script&lang=js&"
export * from "./ProposalsList.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsList.vue?vue&type=style&index=0&id=2e19c7b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e19c7b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VProgressCircular,VTooltip})
